import layoutStates from "src/recoil/atoms/layout"
import { useRecoilValue } from "recoil"
import { useBrowserType } from "src/hooks/useBrowserType"

const useShowFullScreenInterface = props => {
  // const {platform} = window.config
  const platform = "utta"

  const showOnVideoOverlayContent = useRecoilValue(
    layoutStates.showOnVideoOverlayContent
  )
  const isFloatingDivActive = useRecoilValue(layoutStates.isFloatingDivActive)
  const { isMobile } = useBrowserType()

  if (platform === "utta") {
    return {
      showFullScreenInterface:
        (props.isTransparent || props.isLandscape) &&
        showOnVideoOverlayContent &&
        isMobile
    }
  } else {
    return {
      showFullScreenInterface:
        (props.isTransparent || props.isLandscape) &&
        !isFloatingDivActive &&
        showOnVideoOverlayContent
    }
  }
}

export default useShowFullScreenInterface
